var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 691.365,
    height: 586.346,
    viewBox: "0 0 691.365 586.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: -0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.122
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.102
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(-588.635 -80)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(22538.635 6999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M482.764,637.675c51.612-29.22,67.336-29.693,124.954-17.169,81.646,17.758,88.43-49.93,108.306-186.933,33.946-233.98-108.306-295.737-108.306-295.737s-94.6-8.1-150.536-38.963C377.726,55.027,286.9,49.443,207.046,86.542c-51.069,23.7-93.125,56.714-100.31,102.034-20.09,126.746,12.9,196.58-48.819,237.954S48.944,581.5,96.263,577.564c34.968-2.906,80.842,52.415,130.687,60.111,17.382,2.684,88.7-13.043,99.578,0C341.327,655.4,464.763,647.87,482.764,637.675Z",
    transform: "translate(-21979.895 -6980.982)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(-21545.08 -6816.88)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    width: 217.867,
    height: 15.073,
    transform: "translate(0 39.052)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    width: 217.867,
    height: 15.073,
    transform: "translate(0 104.137)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    width: 217.867,
    height: 15.073,
    transform: "translate(0 171.964)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    width: 13.702,
    height: 39.052,
    transform: "translate(19.183)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    width: 13.702,
    height: 2.74,
    transform: "translate(19.183 6.166)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    width: 13.702,
    height: 2.74,
    transform: "translate(19.183 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_269",
    "data-name": "Rectangle 269",
    width: 13.702,
    height: 39.052,
    transform: "translate(39.737)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 13.702,
    height: 2.74,
    transform: "translate(39.737 6.166)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 13.702,
    height: 2.74,
    transform: "translate(39.737 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 13.702,
    height: 39.052,
    transform: "translate(60.29)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 13.702,
    height: 2.74,
    transform: "translate(60.29 6.166)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 13.702,
    height: 2.74,
    transform: "translate(60.29 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 13.702,
    height: 39.052,
    transform: "translate(80.844)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 13.702,
    height: 2.74,
    transform: "translate(80.844 6.166)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 13.702,
    height: 2.74,
    transform: "translate(80.844 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 13.702,
    height: 39.052,
    transform: "translate(101.397)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_279",
    "data-name": "Rectangle 279",
    width: 13.702,
    height: 2.74,
    transform: "translate(101.397 6.166)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_280",
    "data-name": "Rectangle 280",
    width: 13.702,
    height: 2.74,
    transform: "translate(101.397 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 13.702,
    height: 39.052,
    transform: "translate(121.95)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 13.702,
    height: 2.74,
    transform: "translate(121.95 6.166)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 13.702,
    height: 2.74,
    transform: "translate(121.95 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 13.702,
    height: 39.052,
    transform: "translate(142.504)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 13.702,
    height: 2.74,
    transform: "translate(142.504 6.166)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 13.702,
    height: 2.74,
    transform: "translate(142.504 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 13.702,
    height: 39.052,
    transform: "matrix(0.894, -0.448, 0.448, 0.894, 135.847, 138.025)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 13.702,
    height: 2.74,
    transform: "matrix(0.894, -0.448, 0.448, 0.894, 138.614, 143.541)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 13.702,
    height: 2.74,
    transform: "matrix(0.894, -0.448, 0.448, 0.894, 148.128, 162.529)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 13.702,
    height: 39.052,
    transform: "translate(19.183 65.771)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 13.702,
    height: 2.74,
    transform: "translate(19.183 71.937)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 13.702,
    height: 2.74,
    transform: "translate(19.183 93.176)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 13.702,
    height: 39.052,
    transform: "translate(39.737 65.771)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 13.702,
    height: 2.74,
    transform: "translate(39.737 71.937)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 13.702,
    height: 2.74,
    transform: "translate(39.737 93.176)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 13.702,
    height: 39.052,
    transform: "translate(60.29 65.771)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 13.702,
    height: 2.74,
    transform: "translate(60.29 71.937)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 13.702,
    height: 2.74,
    transform: "translate(60.29 93.176)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 13.702,
    height: 39.052,
    transform: "translate(145.93 65.771)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 13.702,
    height: 2.74,
    transform: "translate(145.93 71.937)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 13.702,
    height: 2.74,
    transform: "translate(145.93 93.176)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 13.702,
    height: 39.052,
    transform: "translate(166.483 65.771)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 13.702,
    height: 2.74,
    transform: "translate(166.483 71.937)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 13.702,
    height: 2.74,
    transform: "translate(166.483 93.176)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 13.702,
    height: 39.052,
    transform: "translate(187.036 65.771)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 13.702,
    height: 2.74,
    transform: "translate(187.036 71.937)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 13.702,
    height: 2.74,
    transform: "translate(187.036 93.176)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 13.702,
    height: 39.052,
    transform: "translate(19.183 132.912)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 13.702,
    height: 2.74,
    transform: "translate(19.183 139.078)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 13.702,
    height: 2.74,
    transform: "translate(19.183 160.317)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 13.702,
    height: 39.052,
    transform: "translate(39.737 132.912)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 13.702,
    height: 2.74,
    transform: "translate(39.737 139.078)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 13.702,
    height: 2.74,
    transform: "translate(39.737 160.317)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 13.702,
    height: 39.052,
    transform: "translate(60.29 132.912)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 13.702,
    height: 2.74,
    transform: "translate(60.29 139.078)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 13.702,
    height: 2.74,
    transform: "translate(60.29 160.317)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 13.702,
    height: 39.052,
    transform: "translate(80.844 132.912)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 13.702,
    height: 2.74,
    transform: "translate(80.844 139.078)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 13.702,
    height: 2.74,
    transform: "translate(80.844 160.317)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 13.702,
    height: 39.052,
    transform: "translate(101.397 132.912)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 13.702,
    height: 2.74,
    transform: "translate(101.397 139.078)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 13.702,
    height: 2.74,
    transform: "translate(101.397 160.317)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 13.702,
    height: 39.052,
    transform: "translate(121.95 132.912)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 13.702,
    height: 2.74,
    transform: "translate(121.95 139.078)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 13.702,
    height: 2.74,
    transform: "translate(121.95 160.317)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M797.862,159.09v35.571h-13.7V156.48Q791.039,157.693,797.862,159.09Z",
    transform: "translate(-621.103 -155.61)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 13.702,
    height: 2.74,
    transform: "translate(163.057 6.166)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 13.702,
    height: 2.74,
    transform: "translate(163.057 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M827.862,165.719v30.83h-13.7V162.43c1.781.391,3.556.8,5.33,1.22Q823.7,164.636,827.862,165.719Z",
    transform: "translate(-630.549 -157.483)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M827.862,166.285v.685h-13.7v-2.74h5.33Q823.7,165.2,827.862,166.285Z",
    transform: "translate(-630.549 -158.05)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 13.702,
    height: 2.74,
    transform: "translate(183.611 27.405)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M691.358,287.276s-4.152-1.411-6.166,2.254a6.68,6.68,0,0,0,.089,6.426,9.4,9.4,0,0,0,9.146,5.179c4.35-.233,5.8-3.549,6.166-6.639a6.851,6.851,0,0,0-9.057-7.3Z",
    transform: "translate(-589.693 -196.649)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M686.2,296.239a6.68,6.68,0,0,1-.089-6.426c2-3.659,6.166-2.254,6.166-2.254l.212-.075a6.762,6.762,0,0,1,4.885.11,6.762,6.762,0,0,0-5.762-.548l-.212.075s-4.152-1.411-6.166,2.254a6.68,6.68,0,0,0,.089,6.426,9.982,9.982,0,0,0,4.7,4.446A10.277,10.277,0,0,1,686.2,296.239Z",
    transform: "translate(-589.706 -196.595)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M691.42,290.06s1.542,1.213,5.282,0",
    transform: "translate(-591.9 -197.672)",
    fill: "#00ddf1",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M690.93,277.21s2.638,7.153,2.418,9.023l2.09-.219s-3.521-6.269-2.638-8.8Z",
    transform: "translate(-591.746 -193.626)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M690.93,277.21s2.638,7.153,2.418,9.023l2.09-.219s-3.521-6.269-2.638-8.8Z",
    transform: "translate(-591.746 -193.626)",
    fill: "#00ddf1",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M702.92,277.6s-4.159-2.124-6.015-.37-2.144,6.241-2.144,6.241S701.536,284.391,702.92,277.6Z",
    transform: "translate(-592.952 -193.414)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M702.92,277.6s-4.159-2.124-6.015-.37-2.144,6.241-2.144,6.241S701.536,284.391,702.92,277.6Z",
    transform: "translate(-592.952 -193.414)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M694.75,283.958s1.089-5.207,8.16-5.878",
    transform: "translate(-592.949 -193.9)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M819.358,386.276s-4.152-1.411-6.166,2.254a6.68,6.68,0,0,0,.089,6.426,9.4,9.4,0,0,0,9.146,5.18c4.35-.233,5.8-3.549,6.166-6.639a6.851,6.851,0,0,0-9.057-7.3Z",
    transform: "translate(-629.999 -227.823)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M814.2,395.239a6.68,6.68,0,0,1-.089-6.426c2-3.659,6.166-2.254,6.166-2.254l.212-.075a6.762,6.762,0,0,1,4.885.11,6.762,6.762,0,0,0-5.762-.548l-.212.075s-4.152-1.411-6.166,2.254a6.68,6.68,0,0,0,.089,6.426,9.982,9.982,0,0,0,4.7,4.446A10.276,10.276,0,0,1,814.2,395.239Z",
    transform: "translate(-630.011 -227.769)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M819.42,389.06s1.542,1.213,5.282,0",
    transform: "translate(-632.206 -228.846)",
    fill: "#00ddf1",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M818.93,376.21s2.638,7.153,2.419,9.023l2.09-.219s-3.522-6.269-2.638-8.8Z",
    transform: "translate(-632.051 -224.799)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M818.93,376.21s2.638,7.153,2.419,9.023l2.09-.219s-3.522-6.269-2.638-8.8Z",
    transform: "translate(-632.051 -224.799)",
    fill: "#00ddf1",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M830.92,376.6s-4.159-2.124-6.015-.37-2.144,6.241-2.144,6.241S829.536,383.391,830.92,376.6Z",
    transform: "translate(-633.257 -224.588)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M830.92,376.6s-4.159-2.124-6.015-.37-2.144,6.241-2.144,6.241S829.536,383.391,830.92,376.6Z",
    transform: "translate(-633.257 -224.588)",
    fill: "#00ddf1",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M822.75,382.958s1.089-5.207,8.16-5.878",
    transform: "translate(-633.254 -225.073)",
    fill: "#00ddf1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(7 -63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(21233 8372)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 49.851,
    cy: 8.007,
    rx: 49.851,
    ry: 8.007,
    transform: "translate(-20118.443 -7772.555)",
    fill: "#00abf6",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 3.208,
    height: 72.224,
    transform: "translate(-20070.199 -7917.934)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M1025.906,587.251l-.2,3.254-.287,4.6-.118,1.913-.281,4.6-.123,1.913-.286,4.6-3.233,52.22a8.851,8.851,0,0,1-8.83,8.268H995.731a8.841,8.841,0,0,1-8.82-8.3l-3.244-52.225-.281-4.6-.117-1.913-.292-4.6-.117-1.913-.281-4.6-.2-3.254a4.6,4.6,0,0,1,4.574-4.865h34.391a4.6,4.6,0,0,1,4.569,4.9Z",
    transform: "translate(-21072.734 -8433.181)",
    fill: "#565661"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M990.949,517.36l-.287,4.589H948.106l-.286-4.589Z",
    transform: "translate(-21037.977 -8360.036)",
    fill: "#9d9cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M990.93,530.08l-.281,4.594H948.9l-.286-4.594Z",
    transform: "translate(-21038.363 -8366.248)",
    fill: "#9d9cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M990.912,542.8l-.287,4.589H949.686L949.4,542.8Z",
    transform: "translate(-21038.748 -8372.46)",
    fill: "#9d9cb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M933.875,490.464c18.684,13.517,26.466,34.656,26.466,34.656s-22.511-.773-41.2-14.289-26.46-34.651-26.46-34.651S915.2,476.953,933.875,490.464Z",
    transform: "translate(-21028.934 -8381.328)",
    fill: "#00abf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M892.68,476.18s23.365,12.969,30.865,23.708,36.8,25.233,36.8,25.233",
    transform: "translate(-21028.934 -8381.328)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M975.393,443.457c10.171,7.352,14.407,18.863,14.407,18.863s-12.279-.425-22.424-7.776S953,435.68,953,435.68,965.227,436.1,975.393,443.457Z",
    transform: "translate(-21058.393 -8361.549)",
    fill: "#00abf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M953,435.68s12.719,7.06,16.8,12.9,20.03,13.737,20.03,13.737",
    transform: "translate(-21058.393 -8361.549)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M1040.3,470.483c-11.68,12.836-14.151,29.612-14.151,29.612s16.469-4.042,28.139-16.883,14.151-29.612,14.151-29.612S1051.981,457.647,1040.3,470.483Z",
    transform: "translate(-21094.119 -8370.301)",
    fill: "#00abf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M1068.45,453.61s-15.215,13.159-19.083,22.224S1026.15,500.1,1026.15,500.1",
    transform: "translate(-21094.119 -8370.306)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(-40 36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 12.343,
    height: 37.459,
    transform: "translate(741.459 392.675)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 12.343,
    height: 39.629,
    transform: "translate(1073.647 390.726)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M597.889,523.665v8.446l-98.7.909-1.052.02-37.511.344-.9.013-11.4.1h-.338l-69.5.643L264.408,535.2h-.1l-29.007.273-.312.007L106.1,536.658v-9.745l30.306-18.19,60.808-.507,1.3-.007.429-.007,1.3-.019,29.2-.24,1.306-.007.416-.007,1.3-.006,9.362-.078.247-.006,23.1-.195h.188l180.214-1.52,4.411-.032h.442l3.365-.033,24.459-.2,1.3-.02,1.2-.013h.624l7.607-.058,1.507-.02,2.02-.013,6.334-.058,10.05-.084,1.3-.013,2.261-.013h.422l48.536-.416Z",
    transform: "translate(566.82 43)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M597.889,523.665v8.446l-98.7.909-1.052.02-37.511.344-.9.013-11.4.1h-.338l-69.5.643L264.408,535.2h-.1l-29.007.273-.312.007L106.1,536.658v-9.745l30.306-18.19,60.808-.507,1.3-.007.429-.007,1.3-.019,29.2-.24,1.306-.007.416-.007,1.3-.006,9.362-.078.247-.006,23.1-.195h.188l180.214-1.52,4.411-.032h.442l3.365-.033,24.459-.2,1.3-.02,1.2-.013h.624l7.607-.058,1.507-.02,2.02-.013,6.334-.058,10.05-.084,1.3-.013,2.261-.013h.422l48.536-.416Z",
    transform: "translate(566.82 43)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M358.914,656.57v15.91a3.982,3.982,0,0,1-2.274,3.6,3.9,3.9,0,0,1-1.624.39l-22.673.481a3.9,3.9,0,0,1-1.754-.37,3.976,3.976,0,0,1-2.319-3.619V656.57Z",
    transform: "translate(437.441 -122.381)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M358.914,656.57v15.91a3.982,3.982,0,0,1-2.274,3.6,3.9,3.9,0,0,1-1.624.39l-22.673.481a3.9,3.9,0,0,1-1.754-.37,3.976,3.976,0,0,1-2.319-3.619V656.57Z",
    transform: "translate(437.441 -122.381)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M360.914,656.57v15.91a3.982,3.982,0,0,1-2.274,3.6,3.9,3.9,0,0,1-1.624.39l-22.673.481a3.9,3.9,0,0,1-1.754-.37,3.976,3.976,0,0,1-2.319-3.619V656.57Z",
    transform: "translate(436.74 -122.381)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 30.644,
    height: 20.464,
    transform: "translate(1046.362 534.189)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 30.644,
    height: 20.464,
    transform: "translate(1046.362 534.189)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_258",
    "data-name": "Rectangle 258",
    width: 30.644,
    height: 20.464,
    transform: "translate(1045.062 534.189)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M223.943,265.82v3.723l-12.343-.318v-3.4Z",
    transform: "translate(529.859 126.848)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M358.741,271.246,343.909,377.789a2.794,2.794,0,0,1-2.839,2.41L222.314,377.12l-2.254-.058a2.794,2.794,0,0,1-2.7-3.164l16.651-111.533a2.794,2.794,0,0,1,2.949-2.358l119.186,8.069a2.787,2.787,0,0,1,2.6,3.17Z",
    transform: "translate(476.307 16.556)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M169.158,99.16,156.6,197.472l109.142,3.463,13.422-94.85Z",
    transform: "translate(549.128 185.237)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    width: 132.965,
    height: 112.605,
    rx: 5.33,
    transform: "translate(853.849 282.877)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 120.836,
    height: 93.765,
    transform: "translate(860.125 290.458)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M735.273,262.82v2.462l-12.343.253V262.82Z",
    transform: "translate(350.717 127.899)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M833.626,371a2,2,0,0,1-1.949,2.131l-121.615,2.514a2,2,0,0,1-2.033-1.813L697.575,265.156a2,2,0,0,1,1.9-2.189l120.693-6,1.3-.065a1.994,1.994,0,0,1,2.092,1.819Z",
    transform: "translate(308.06 17.643)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M628.93,100.238,739.157,94.82l9.31,98.748-109.356,2.6Z",
    transform: "translate(383.65 186.757)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M899.741,371a2,2,0,0,1-1.949,2.131L886.28,256.963l1.3-.065a2,2,0,0,1,2.092,1.819Z",
    transform: "translate(241.945 17.643)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 12.343,
    height: 11.096,
    transform: "translate(741.459 419.038)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M281.574,483.65v3.229l-30.644.819V483.65Z",
    transform: "translate(516.08 50.533)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M390.8,483.886V593.158a2.6,2.6,0,0,1-2.5,2.566l-124.506,3.313h-.033a2.6,2.6,0,0,1-2.566-2.566V483.886a2.6,2.6,0,0,1,2.566-2.566H388.23A2.6,2.6,0,0,1,390.8,483.886Z",
    transform: "translate(460.942 -60.983)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M194.6,319.15H309.914v96.311L194.6,418.06Z",
    transform: "translate(535.815 108.164)",
    fill: "#d4dfec"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    width: 12.343,
    height: 11.317,
    transform: "translate(1073.647 419.038)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M709.574,483.65v4.164L678.93,487V483.65Z",
    transform: "translate(366.132 50.533)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M797.782,483.886V596.471a2.6,2.6,0,0,1-2.6,2.566h0l-124.532-3.313a2.6,2.6,0,0,1-2.5-2.566V483.886a2.6,2.6,0,0,1,2.566-2.566H795.19a2.6,2.6,0,0,1,2.592,2.566Z",
    transform: "translate(318.365 -60.983)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M866.289,483.886V596.471a2.6,2.6,0,0,1-2.6,2.566h0V481.32h0a2.6,2.6,0,0,1,2.6,2.566Z",
    transform: "translate(249.859 -60.983)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M713.414,319.15H598.1v96.311l115.314,2.6Z",
    transform: "translate(394.451 108.164)",
    fill: "#d4dfec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M593.3,483.886V593.158a2.6,2.6,0,0,1-2.5,2.566l-124.506,3.313h0a2.6,2.6,0,0,1-2.6-2.566V483.886a2.6,2.6,0,0,1,2.566-2.566H590.73A2.6,2.6,0,0,1,593.3,483.886Z",
    transform: "translate(389.997 -60.983)",
    fill: "#65617d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M397.1,319.15H512.414v96.311L397.1,418.06Z",
    transform: "translate(464.87 108.164)",
    fill: "#d4dfec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M597.889,533.65V542.1l-98.7.909-1.052.02-37.511.344-.9.013-11.4.1h-.338l-69.5.643-114.086,1.059h-.1l-29.007.273-.312.007L106.1,546.643V536.9l131.562-.864h.312l26.629-.182h.123l183.9-1.215h.188l.11-.006h.305l3.112-.019h.948l48.393-.325,2.858-.013.637-.007Z",
    transform: "translate(566.82 33.015)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_99",
    "data-name": "Ellipse 99",
    cx: 33.347,
    cy: 33.347,
    r: 33.347,
    transform: "translate(887.196 363.44)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M383.74,592.973a.806.806,0,0,1,.065-.227c.65-2.332,1.806-6.276,2.67-9.427.11-.39.214-.773.312-1.137.955-3.554,2.813-11.876,3.846-17.066.364-1.826.65-3.248.708-3.963.13-1.1,2.085-5.795,4.3-11.194,1.553-3.794,3.248-7.939,4.489-11.434a39.876,39.876,0,0,0,1.9-6.4,3.313,3.313,0,0,0,0-1.384,9.543,9.543,0,0,1-.312-2.274h0c-.149-4.028,1.052-10.394,2.91-13.065,2.274-3.248,3.9-15.371,3.9-15.371s3.365.487,3.9-2.293a4,4,0,0,0,.065-.91,4.815,4.815,0,0,0-.058-.721c-.578-4.054,9.563-8.368,15.267-9.3a12.769,12.769,0,0,1,1.949-.182,17.694,17.694,0,0,0,4.06-.935q.909-.279,1.949-.65c2.391-.806,5.249-1.871,8.283-3.04,11.408-4.424,25.22-10.394,25.22-10.394.1-.461.208-.9.331-1.338a18,18,0,0,1,10.622-12.3h0v-1.3c0-2.241-.1-4.548-.195-6.847,0-.448-.039-.9-.065-1.345v-.734c0-.455-.046-.91-.071-1.358l-.117-.091a10.66,10.66,0,0,1-2.534-2.729,9.916,9.916,0,0,1-.923-1.949c-.812-2.2-1-4.658-1.546-6.984l-.117-.481a54.579,54.579,0,0,0-2.6-6.873c-1.436-3.521-2.54-7.146-3.638-10.817q-1-3.333-2.02-6.678l-1.026-3.4c-.195-.65-.39-1.3-.539-1.949h0a8.627,8.627,0,0,1-.169-.91h0a6.5,6.5,0,0,1,.156-2.995,20.854,20.854,0,0,1,.858-1.949,5.113,5.113,0,0,0,.325-.9h0a1.947,1.947,0,0,0,.052-.208,3.667,3.667,0,0,0,.071-.7,11.993,11.993,0,0,0-.338-2.527.045.045,0,0,1,0-.032,1.661,1.661,0,0,0-.032-.175,16.564,16.564,0,0,1-.234-1.949,18.483,18.483,0,0,1,2.254-10.115l.123-.234a16.383,16.383,0,0,1,1.2-1.806h0a9.122,9.122,0,0,1,.65-.793,2.594,2.594,0,0,1-3.606-.936,2.475,2.475,0,0,1-.149-.292c-.033-.078-.059-.162-.085-.247-.455-1.592.338-3.287,1.377-4.58a12.012,12.012,0,0,1,3.729-3.053h0a2.51,2.51,0,0,1,.26-.136,11.125,11.125,0,0,1,1.715-.689h0a9.781,9.781,0,0,1,1.059-.286l-2.41-.221-.974-.091A9.414,9.414,0,0,1,479,361.527h.7a7.625,7.625,0,0,1,1.02.084A2.885,2.885,0,0,1,479,358.8a9.362,9.362,0,0,0,5.97,1.988h.247a19.494,19.494,0,0,1-.221-2.124h0a21.545,21.545,0,0,1,0-2.9,5.483,5.483,0,0,0,4.4,1.468l-1.351-1.884a6.165,6.165,0,0,0,4.262,1.332l.312-.033a4.547,4.547,0,0,0,.773-.149h.058c-.123-.156-.234-.318-.344-.487l-.039-.078a6.282,6.282,0,0,1-.65-1.358,4.284,4.284,0,0,1-.156-.565h0a5.684,5.684,0,0,1,.292-3.541c2.1,1.754,4.4,4.151,7.146,2.339s2.839-5.139,7.146-4.8a6.626,6.626,0,0,1,5.464,3.976,4.385,4.385,0,0,1,4.983-1.137,4.45,4.45,0,0,1,2.521,4.476c1.786-.448,3.71-.89,5.425-.214s2.82,2.865,1.845,4.327a.931.931,0,0,1-.091.13c-.8,1.033-2.566,1.6-2.378,2.9l.273.195.845.611q4.97,3.586,9.68,7.536c1.611,1.351,3.326,2.975,3.437,5.087a5.617,5.617,0,0,1-.156,1.54h0c-.1.507-.247,1.013-.357,1.52a12.676,12.676,0,0,0-.221,3.93h0c.045.383.1.76.175,1.143.994,5.022,5.009,9.167,5.405,14.292v.364a11.546,11.546,0,0,1-.045,1.644c-.3,3.118-1.741,6.113-2.91,9.1-.072.182-.143.364-.208.546a90.5,90.5,0,0,0-4.548,18.294,65.14,65.14,0,0,1-1.3,6.555,17.365,17.365,0,0,1-3.307,6.776,10.536,10.536,0,0,1-2.183,1.949,12.132,12.132,0,0,1-1.722.916v.039c.071.4.13.793.2,1.189.039.208.071.416.11.65h0a.089.089,0,0,0,0,.039c.546,3.073,1.169,6.081,1.826,8.939l.331,1.423c8.186,2.956,9.154,9.011,9.212,11.33a6.259,6.259,0,0,1,0,.929s12.343.325,17.216,3.9a13.21,13.21,0,0,0,2.93,1.494,53.917,53.917,0,0,0,6.009,1.877c1.046.273,2.137.539,3.248.8,1.949.448,4.015.884,6.009,1.3,5.321,1.072,10.33,1.949,12.87,2.6,6.061,1.533,19.925,14.825,19.925,14.825s1.624,13.409,3.248,15.364,4.548,8.829,4.548,8.829l10.745,19.106,4.548,8.036h2.923a4.97,4.97,0,0,1,2.085,1.364c.773.689,1.631,1.546,2.384,2.326l1.247,1.332.78.864s4.723.117,6,3.852c3.846-.11,8.569.143,11.876,1.624a9.187,9.187,0,0,1,1.3.7,5.639,5.639,0,0,1,2.683,3.677,5.422,5.422,0,0,1,.117.935c0,.37,0,.741,0,1.1-.234,4.918-3.437,9.011-6.38,11.765l.208.37s-.1.234-.286.65c-.052.123-.117.26-.188.416h0c-.383.819-.994,2.046-1.793,3.482a41.136,41.136,0,0,1-6.217,8.556l-.188.195-37.511.344-.11-.13-7.276-8.679-3.619-4.314-.11-.136-.1,1.033-.351,3.443-.845,8.322-.045.416v.11l-.1.961.071-.961h-.188l-69.513.65-114.092,1.26v.546h-.091v-.546l-29.072.312Z",
    transform: "translate(418.007 -14.269)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M586.185,511.522s-64.641,7.8-58.469,0c2.235-2.82,2.852-11.174,2.729-20.691-.039-2.891-.143-5.886-.292-8.868-.715-14.292-2.436-28.26-2.436-28.26s56.52-26.636,50.023-5.522c-2.6,8.53-1.748,20.51.227,31.755.578,3.281,1.247,6.5,1.949,9.55a223.892,223.892,0,0,0,6.269,22.036Z",
    transform: "translate(367.711 -46.521)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M586.185,537.354s-64.641,7.8-58.469,0c2.235-2.82,2.852-11.174,2.729-20.692,9.855-4.21,22.394-1.072,22.394-1.072,13.2-2.631,21.666-2.118,27.078-.273A223.888,223.888,0,0,0,586.185,537.354Z",
    transform: "translate(367.711 -72.353)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M413.346,651.973v-.546l114.092-1.241,69.513-.65h.195l-.071.961.1-.961h.123v-.11l.89-8.738.338-3.307.1-1.033.091-.864,4.015-13.389,4.015-13.37,3.378-11.258,5.158-17.2s-2.923-6.821-4.548-8.77-3.248-15.267-3.248-15.267-13.864-13.208-19.925-14.728c-2.54-.65-7.555-1.514-12.883-2.6-1.994-.4-4.041-.832-6.009-1.3-1.111-.253-2.2-.52-3.248-.786a57.086,57.086,0,0,1-6.009-1.858,13.448,13.448,0,0,1-2.924-1.488c-4.775-3.5-16.742-3.9-17.2-3.9h0a.269.269,0,0,1,0-.045v-.058a6.66,6.66,0,0,0,0-.819,5.208,5.208,0,0,0-.059-.91.82.82,0,0,0-.045-.325c-.032-.234-.071-.481-.13-.741a3.226,3.226,0,0,0-.078-.344,11.181,11.181,0,0,0-.812-2.267c-.045-.1-.1-.214-.156-.318a11.861,11.861,0,0,0-1.1-1.709c-.084-.11-.175-.227-.273-.338a12.721,12.721,0,0,0-1.767-1.715c-.175-.136-.357-.279-.546-.409a3.026,3.026,0,0,0-.331-.234l-.578-.377-.539-.312c-.474-.26-.974-.513-1.52-.754-.169-.078-.351-.149-.533-.221s-.468-.182-.708-.273h-.039l-.487-.195c-.37-.123-.747-.234-1.143-.344l-.6-.156-.65-.149-.65-.136c-.65-.13-1.345-.247-2.072-.338l-.741-.091-.76-.078-.786-.065-1.117-.065-1.3-.045a81.017,81.017,0,0,0-17.054,1.814,46.946,46.946,0,0,0-11.855-1.093h-.565l-.65.039h-.416l-.838.078a6.224,6.224,0,0,0-.845.1c-.279.039-.572.071-.851.117l-.429.071c-.422.071-.851.149-1.3.24q-.214.039-.429.1c-.565.123-1.13.273-1.689.442-.279.078-.559.169-.838.266-.143.039-.279.091-.416.143l-.416.149-.409.162-.487.195c-.247.1-.487.214-.728.331-.136.058-.273.123-.4.195s-.266.13-.39.2a18.03,18.03,0,0,0-4.034,2.846l-.331.318-.325.331c-.11.11-.214.227-.318.344a15.473,15.473,0,0,0-1.182,1.462c-.1.136-.2.273-.3.416a17.335,17.335,0,0,0-1.117,1.9c-.084.156-.162.318-.24.474a21.243,21.243,0,0,0-1.3,3.411q-.182.65-.331,1.3s-13.753,6.068-25.161,10.46c-3.034,1.169-5.892,2.228-8.283,3.027-.7.234-1.345.448-1.949.65a17.347,17.347,0,0,1-4.06.935,12.778,12.778,0,0,0-1.949.182c-5.243.851-14.227,4.548-15.208,8.257a2.4,2.4,0,0,0-.065.91v.071c.65,4.548-3.9,3.9-3.9,3.9s-1.624,12.019-3.9,15.267c-1.644,2.339-2.768,7.555-2.91,11.492h0a12.741,12.741,0,0,0,.286,3.658v.091c.26.871-.364,3.248-1.423,6.3-1.15,3.346-2.826,7.5-4.437,11.427-2.43,5.925-4.716,11.3-4.859,12.486-.058.526-.227,1.468-.461,2.683-.948,4.95-3.053,14.377-4.093,18.19-.773,2.845-1.9,6.743-2.67,9.42a.91.91,0,0,1-.065.227l29.124-.286v.546h.091Z",
    transform: "translate(417.856 -73.042)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M445.44,607.57s37.03,19.165,50.348,16.891Z",
    transform: "translate(396.391 -105.214)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M561.44,595.57s36.056,11.694,48.074,13.318S561.44,595.57,561.44,595.57Z",
    transform: "translate(355.751 -101.01)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M585.443,530.686c-18.84,3.469-54.311,2.722-69.643,2.2,5.62-20.139,33.022-13.292,33.022-13.292C582.74,512.821,585.339,526.866,585.443,530.686Z",
    transform: "translate(371.74 -73.754)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M585.443,528.686c-18.84,3.469-54.311,2.722-69.643,2.2,5.62-20.139,33.022-13.292,33.022-13.292C582.74,510.821,585.339,524.866,585.443,528.686Z",
    transform: "translate(371.74 -73.053)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M776.94,672.008s22.192-3.411,22.628,6.334S788.25,694.9,788.25,694.9Z",
    transform: "translate(280.251 -127.587)",
    fill: "#fbbebe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M578.17,479.936a30.558,30.558,0,0,1-2.923,1.13c-7,2.417-14.065,4.853-21.439,5.736s-15.111.1-21.543-3.573a18.685,18.685,0,0,1-1.949-1.267c-.715-14.292-2.436-28.26-2.436-28.26s56.52-26.636,50.023-5.522C575.318,456.711,576.195,468.69,578.17,479.936Z",
    transform: "translate(367.508 -46.521)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M536.9,360.29a6.153,6.153,0,0,1-5.405-1.137l1.351,1.878a5.5,5.5,0,0,1-4.4-1.462,22.146,22.146,0,0,0,.208,5.035,9.433,9.433,0,0,1-6.211-1.949,2.872,2.872,0,0,0,1.715,2.8,9.316,9.316,0,0,0-10.135,6.958l3.391.312a12,12,0,0,0-6.782,4.138c-1.039,1.3-1.832,2.962-1.377,4.548s2.651,2.6,3.846,1.468a18.151,18.151,0,0,0-3.963,14.806,9.4,9.4,0,0,1,.3,3.417,28.993,28.993,0,0,1-1.228,3.047c-.65,1.9-.032,3.956.546,5.847l3.047,10.018c1.1,3.619,2.2,7.244,3.645,10.745a53.328,53.328,0,0,1,2.6,6.828c.819,3.144.851,6.588,2.6,9.336a12.948,12.948,0,0,0,4.665,4.112c6.425,3.677,14.188,4.457,21.542,3.573s14.409-3.32,21.406-5.736a20.141,20.141,0,0,0,4.444-1.949c4.84-3.17,5.918-9.654,6.821-15.364a87.242,87.242,0,0,1,4.736-18.71c1.416-3.567,3.248-7.185,2.936-11.005-.4-5.074-4.411-9.186-5.405-14.175a12.344,12.344,0,0,1,.045-5.048,11.473,11.473,0,0,0,.513-3.053c-.11-2.092-1.826-3.7-3.437-5.048q-5.243-4.379-10.823-8.277c-.188-1.3,1.579-1.858,2.378-2.884,1.13-1.449-.039-3.748-1.754-4.424s-3.638-.234-5.425.214a4.281,4.281,0,0,0-7.5-3.32,6.627,6.627,0,0,0-5.47-3.95c-4.307-.338-4.392,2.956-7.146,4.768s-5.028-.578-7.146-2.319A6.029,6.029,0,0,0,536.9,360.29Z",
    transform: "translate(374.5 -15.625)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M768.171,669.128s-.578,1.377-1.644,3.372a44.83,44.83,0,0,1-5.847,8.556l-.175.188h-1.052l-37.511.344h-.9l-.11-.13-7.276-8.634-2.741-3.255-.11-.136-.234-.273-.13-.156-.169-.2-5.334-6.328,1.949-8.121,3.32-13.682.084-.331.65-2.6.461-1.949,1.546-6.354,5.3-21.861,9.42,4.872,9.933,17.541,5.334,9.42h2.923c.552,0,1.819,1.065,3.092,2.293.455.435.91.9,1.3,1.3,1.156,1.2,2.072,2.222,2.072,2.222s4.736.1,6.009,3.833a4.537,4.537,0,0,1,.162.552,26.191,26.191,0,0,0,1.644,4.262c.838,1.826,1.891,3.9,2.956,5.97,1.981,3.8,4,7.419,4.736,8.731l.091.162Z",
    transform: "translate(305.476 -105.217)",
    fill: "#00ddf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M615.681,653.093l-.065.929v.065l-.11,1.494-.864,12.025L613.6,682.093l-.3,4.08-.65,8.731v.11l-69.513.65L429.061,696.9v.546h-.091v-.728l.292-9.329.559-18.229L430.3,653.7l.045-1.54a6.841,6.841,0,0,1,7.419-6.607c3.066.26,7.049.578,11.811.916l1.949.143c27.5,1.91,78.322,4.379,129.606,1.3,1.078-.059,2.163-.123,3.248-.2,7.952-.5,15.9-1.143,23.764-1.949a6.841,6.841,0,0,1,7.536,7.3Z",
    transform: "translate(402.161 -118.514)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M429.08,698.857v-.546l114.092-1.241,69.513-.65h.195v-.11l.65-8.731.279-3.9,1.065-14.689.838-11.629v-.286a6.893,6.893,0,0,0-.071-1.6.2.2,0,0,0,0-.065,6.751,6.751,0,0,0-1.3-3.014,6.847,6.847,0,0,0-6.12-2.6c-7.867.806-15.813,1.449-23.764,1.949-1.085.078-2.17.143-3.248.2-51.284,3.047-102.106.578-129.606-1.3l-1.949-.143c-4.762-.338-8.744-.65-11.811-.916a6.847,6.847,0,0,0-7.3,5.542,7.146,7.146,0,0,0-.117,1.065l-.442,14.4-.6,18.236-.286,9.329v.728Z",
    transform: "translate(402.122 -119.926)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M615.925,661.692l-.8,9.959L613.937,686.5l-.3,3.716-.65,8.322-.039.416v.11h0l-.1.961.071-.961h-.188l-69.513.65L429.11,700.944v-.182l.318-9.329.65-18.229.416-12.116a4.132,4.132,0,0,1,1.988-3.411,4.061,4.061,0,0,1,2.456-.585c1.364.11,3.04.24,5,.383,3.177.234,7.094.507,11.655.793,8.445.533,19.041,1.1,31.183,1.572,33.782,1.3,79.388,1.735,122.707-2.059,1.949-.169,3.963-.357,5.931-.546a4.066,4.066,0,0,1,2.261.429,3.346,3.346,0,0,1,.559.351,3.989,3.989,0,0,1,1.3,1.6,2.315,2.315,0,0,1,.162.4A4.08,4.08,0,0,1,615.925,661.692Z",
    transform: "translate(402.112 -122.559)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M360.914,677.87v2.072a3.982,3.982,0,0,1-2.274,3.6l-26.051.5a3.976,3.976,0,0,1-2.319-3.619v-1.949Z",
    transform: "translate(436.74 -129.843)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M280.294,512.532l-33.944.65V507.55l33.944-.65Z",
    transform: "translate(517.685 42.387)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M280.294,512.532l-33.944.65V507.55l33.944-.65Z",
    transform: "translate(517.685 42.387)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M282.294,512.532l-33.944.65V507.55l33.944-.65Z",
    transform: "translate(516.984 42.387)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M552.228,360.039A6.334,6.334,0,0,1,551,357.22a6.165,6.165,0,0,0,.273,2.988A5.847,5.847,0,0,0,552.228,360.039Z",
    transform: "translate(359.434 -17.505)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M540.1,366.9a22.83,22.83,0,0,1-.24-2.4c0,.8,0,1.6,0,2.41Z",
    transform: "translate(363.311 -20.056)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M621.706,398.627a11.912,11.912,0,0,1,.234-1.722,11.7,11.7,0,0,0,.52-3.047,4.008,4.008,0,0,0-.1-.689c-.11.6-.286,1.2-.416,1.787a12.433,12.433,0,0,0-.234,3.671Z",
    transform: "translate(334.652 -30.1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M600.922,368.894l.708.513a12.8,12.8,0,0,0,1.67-1.442,2.384,2.384,0,0,0,.247-2.365,1.95,1.95,0,0,1-.247.416C602.5,367.042,600.734,367.607,600.922,368.894Z",
    transform: "translate(341.923 -20.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M518.455,380.29a8,8,0,0,0-.565,1.481,11.8,11.8,0,0,1,3.248-1.228Z",
    transform: "translate(371.008 -25.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M531.888,368.979a9.637,9.637,0,0,1-1.221-.8,2.758,2.758,0,0,0,.058.767,7.7,7.7,0,0,1,1.163.033Z",
    transform: "translate(366.534 -21.345)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M587.579,428.33c-.266,3.151-1.735,6.185-2.923,9.173a87.2,87.2,0,0,0-4.736,18.717c-.9,5.71-1.949,12.194-6.821,15.358a19.488,19.488,0,0,1-4.437,1.949c-7,2.423-14.065,4.853-21.439,5.736s-15.111.11-21.543-3.567a12.993,12.993,0,0,1-4.664-4.112c-1.735-2.748-1.767-6.191-2.6-9.336a53.424,53.424,0,0,0-2.6-6.834c-1.436-3.5-2.54-7.146-3.638-10.739q-1.527-5.009-3.047-10.024a18.716,18.716,0,0,1-.741-3.086,11.644,11.644,0,0,0,.741,5.035q1.52,5.022,3.047,10.024c1.1,3.619,2.2,7.244,3.638,10.739a53.417,53.417,0,0,1,2.6,6.834c.819,3.144.851,6.587,2.6,9.336a12.993,12.993,0,0,0,4.664,4.112c6.432,3.677,14.188,4.45,21.543,3.567s14.409-3.313,21.439-5.736a19.487,19.487,0,0,0,4.437-1.949c4.84-3.164,5.918-9.647,6.821-15.358a87.2,87.2,0,0,1,4.736-18.717c1.416-3.56,3.248-7.179,2.936-11.005C587.592,428.408,587.579,428.369,587.579,428.33Z",
    transform: "translate(374.359 -42.418)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M510.318,421.419v-.071a9.1,9.1,0,0,0-.3-3.411,17.272,17.272,0,0,1-.253-2.157,17.769,17.769,0,0,0,.253,4.106C510.123,420.393,510.24,420.906,510.318,421.419Z",
    transform: "translate(373.864 -38.021)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M512.452,397.929a18.02,18.02,0,0,1,1.7-2.384c-1.189,1.137-3.385.123-3.846-1.455a3.788,3.788,0,0,0,0,1.949,2.852,2.852,0,0,0,2.15,1.89Z",
    transform: "translate(373.712 -30.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M762.946,656.57s2.059,7.471,0,13.968S762.946,656.57,762.946,656.57Z",
    transform: "translate(285.475 -122.381)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M776,668.3s.864,9.485-1.085,11.168S776,668.3,776,668.3Z",
    transform: "translate(281.189 -126.49)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    y1: 0.65,
    x2: 66.011,
    transform: "translate(733.267 442.068)",
    fill: "none",
    stroke: "#00ddf1",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    y1: 0.643,
    x2: 66.011,
    transform: "translate(733.267 450.176)",
    fill: "none",
    stroke: "#00ddf1",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    y1: 0.65,
    x2: 66.011,
    transform: "translate(733.267 458.277)",
    fill: "none",
    stroke: "#00ddf1",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImg);
export default __webpack_public_path__ + "static/media/login_img.8408eaa02c5e8edff164e682b7245c3a.svg";
export { ForwardRef as ReactComponent };